import { render, staticRenderFns } from "./OutsourceCheckDetail.vue?vue&type=template&id=a0896514&scoped=true"
import script from "./OutsourceCheckDetail.vue?vue&type=script&lang=js"
export * from "./OutsourceCheckDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0896514",
  null
  
)

export default component.exports